export default "__VITE_ASSET__D8XbJ0N0__"